module.exports = __webpack_public_path__ + "img/check_3.d58e212b.png";